<template>
  <div class="multi-account-page page-max-width footer-max-width">
    <QHeader v-if="!typeformLink" class="bg-white text-primary">
      <QToolbar>
        <QBtn round color="primary" icon="icon-f-arrow-left" dense flat @click="onClickBack" />

        <QToolbarTitle>
          {{ $t("ETAB.PAGES.MULTI_ACCOUNT.@ETABLISSEMENTS") }}
        </QToolbarTitle>
      </QToolbar>
    </QHeader>
    <QPageContainer>
      <QPage>
        <MultiAccountModal v-if="typeformLink" :typeform-link="typeformLink" />
        <MultiAccountComponent v-else :available-etablissements="availableEtablissements" :selected-etab="selectedEtab" />
      </QPage>
    </QPageContainer>
  </div>
</template>

<script>
  import { MultiAccountService } from "@core/services";
  import { MultiAccountModel, MultiAccountEtabModel, ISupervisedEtab } from "@core/models";
  import MultiAccountModal from "@etab/components/account/MultiAccountModal.component.vue";
  import MultiAccountComponent from "@etab/components/account/MultiAccount.component.vue";
  import { UserStorageManager } from "@core/managers/user-storage.manager";
  import { ETAB_ROUTES } from "@etab/config";
  import { ROLE } from "@core/constants";

  export default {
    components: {
      MultiAccountModal,
      MultiAccountComponent,
    },
    data() {
      return {
        availableEtablissements: [],
        typeformLink: undefined,
        selectedEtab: undefined,
        unselectedEtab: undefined,
      };
    },
    created() {
      this.initRoleData();
    },
    methods: {
      async initRoleData() {
        const user = await UserStorageManager.getUser();
        if (user.role[0] === ROLE.MASTER) {
          this.getAvailableEtablissements();
        } else {
          this.getTypeformLink();
        }
      },
      async getAvailableEtablissements() {
        try {
          this.$_startGlobalLoading();
          const etablissements = await MultiAccountService.getEtablissements();
          this.availableEtablissements = etablissements.map((etablissement) => new MultiAccountEtabModel(etablissement));
          const hasSupervisedEtab = await UserStorageManager.getSupervisorData();
          if (hasSupervisedEtab) {
            this.setSelectedSupervisedEtab(hasSupervisedEtab);
            this.getUnselectedEtab(hasSupervisedEtab);
          }
        } catch (error) {
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      async getTypeformLink() {
        try {
          const typeformLink = await MultiAccountService.getMultiAccountTypeformLink();
          this.typeformLink = new MultiAccountModel(typeformLink).getLink();
        } catch (error) {
          throw error;
        }
      },
      setSelectedSupervisedEtab(hasSupervisedEtab) {
        const supervisedEtabId = hasSupervisedEtab[ISupervisedEtab.supervisedEtabId];
        this.selectedEtab = this.availableEtablissements.find((etab) => etab.getId() === String(supervisedEtabId));
      },
      getUnselectedEtab(hasSupervisedEtab) {
        const supervisedEtabId = hasSupervisedEtab[ISupervisedEtab.supervisedEtabId];
        this.availableEtablissements = this.availableEtablissements.filter((etab) => etab.getId() !== String(supervisedEtabId));
      },
      onClickBack() {
        this.$router.push({ name: ETAB_ROUTES.userMenu.root.name }).catch((suppressedError) => {});
      },
    },
  };
</script>
<style lang="scss">
  .multi-account-page {
    .q-page {
      padding: 15px;
    }

    h4 {
      color: $primary-lighter;
    }
  }
</style>
